// config.js
// Viteの環境変数
const viteApiUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_API_URL : undefined;

// CRAの環境変数
const craApiUrl = typeof process !== 'undefined' && process.env ? process.env.REACT_APP_API_URL : undefined;

// デフォルトのAPIのURL（本番環境と開発環境で切り替え）
// 本番はフロントとAPIを同一オリジンで配信しているため window.location.origin を使う
// （ドメイン直書きだと co-edu / compass / origin など複数ホスト名に追従できない）
const defaultApiUrl = window.location.hostname === 'localhost'
  ? 'http://localhost:8000'
  : window.location.origin;

// 優先順位付きで設定
export const API_URL = viteApiUrl || craApiUrl || defaultApiUrl;